module.exports = __webpack_public_path__ + "img/bg-footer-menicon.99846eeb.svg";